// extracted by mini-css-extract-plugin
module.exports = {"spread-button":"CashCreditDifferential_spread-button__1r7we"};